import { List } from "@blacknut/javascript-sdk/dist";
import { Dispatch } from "redux";
import { ListAction, ListActionTypes, FAVORITES_LIST_ID } from "./List";
import { getFavorites as apiGetFavorites } from "@blacknut/javascript-sdk/dist/api/Catalog/getFavorites";
import { State } from "../../reducers";

export const paginateFavorites = (list: List, limit = 6) => {
  return (dispatch: Dispatch<ListAction>, getState: () => State) => {
    return new Promise<List>((resolve, reject) => {
      dispatch({ type: ListActionTypes.LIST_PAGINATION_REQUEST, id: list.uuid });
      apiGetFavorites(
        getState().listsState.lists[FAVORITES_LIST_ID].sort,
        1 + Math.floor(list.tiles.length / limit),
        limit,
      ).subscribe({
        next: (res) => {
          const newList = {
            ...list,
            tiles: list.tiles.concat(
              res.games.map((game) => {
                return {
                  game,
                };
              }),
            ),
          };
          dispatch({
            type: ListActionTypes.LIST_PAGINATION_SUCCESS,
            id: list.uuid,
            list: newList,
          });
          resolve(newList);
        },
        error: (error) => {
          dispatch({
            type: ListActionTypes.LIST_PAGINATION_ERROR,
            error,
            id: list.uuid,
          });
          reject(error);
        },
      });
    });
  };
};
